export const useActorHelpers = (actors: any[]) => {
  const sorted = actors.sort((a, b) => {
    if (a.gender === "girl" && b.gender === "guy") return -1
    if (a.gender === "guy" && b.gender === "girl") return 1
    return 0
  })

  return {
    sorted,
  }
}
